import React from "react";
import { Dialog } from "primereact/dialog";
import AddingNewState from "../add-state/state-adding";
 
const AddState = ({
  showAddUserModal,
  hideAddUserModal
}: any) => {
  return (
    <Dialog
      visible={showAddUserModal}
      className="quickview"
      breakpoints={{ "1400px": "45vw", "641px": "80vw" }}
      modal
      onHide={hideAddUserModal}
    >
      <AddingNewState />
    </Dialog>
  );
};
 
export default AddState;
 
 
 